import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import ActionBar from "../shared/general/ActionBar";
import "../general-styles/tab-navigation-styles.scss";
import applicationType from "../Kanban/types/applicationType";
import jobProfileType from "../JobProfile/types/jobProfileType";
import agentsType from "../Agents/types/agentsType";
import { GlobalStyle } from "../TabNavigation/styles/router-nav-styles";
import jobStatusWidgetType from "../JobProfile/types/jobStatusWidgetType";
import EmployerJobHubTabNavigation from "../TabNavigation/EmployerJobHubTabNavigation";

class EmployerJobHub extends Component {
  constructor(props) {
    super(props);
    const { jobProfile } = this.props;
    const { jobTitle, location, salaryRange } = jobProfile;
    this.state = {
      actionBarTitle: `${jobTitle} - ${location}, ${salaryRange}`,
      actionBarMobileTitle: jobTitle,
      actionBarSubtitle: `${location}, ${salaryRange}`,
    };
  }

  getActionBarData = (data) => {
    this.setState({
      actionBarTitle: `${data.title} - ${data.subtitle}`,
      actionBarMobileTitle: data.title,
      actionBarSubtitle: data.subtitle,
    });
  };

  render() {
    const {
      jobProfile,
      applications,
      agents,
      backLinkUrl,
      isRecruiter,
      jobStatusWidget,
      unreadApplicationsCount,
      isPortalEmployer,
      employerId,
      employerUserId,
    } = this.props;

    const { actionBarTitle, actionBarMobileTitle, actionBarSubtitle } =
      this.state;

    return (
      <Fragment>
        <GlobalStyle />
        <ActionBar
          backLink="Jobs"
          backLinkUrl={backLinkUrl}
          title={actionBarTitle}
          mobileTitle={actionBarMobileTitle}
          subtitle={actionBarSubtitle}
          mobileBackButton
        />
        <div style={{ background: "#e4e5e7", height: "calc(100vh - 60px)" }}>
          <EmployerJobHubTabNavigation
            jobProfile={jobProfile}
            getActionBarData={this.getActionBarData}
            agents={agents}
            applications={applications}
            isRecruiter={isRecruiter}
            jobStatusWidget={jobStatusWidget}
            unreadApplicationsCount={unreadApplicationsCount}
            isPortalEmployer={isPortalEmployer}
            employerId={employerId}
            employerUserId={employerUserId}
          />
        </div>
      </Fragment>
    );
  }
}

EmployerJobHub.propTypes = {
  agents: agentsType.isRequired,
  applications: PropTypes.arrayOf(applicationType),
  backLinkUrl: PropTypes.string.isRequired,
  isRecruiter: PropTypes.bool.isRequired,
  jobProfile: jobProfileType.isRequired,
  jobStatusWidget: jobStatusWidgetType.isRequired,
  unreadApplicationsCount: PropTypes.number.isRequired,
  isPortalEmployer: PropTypes.bool.isRequired,
  employerId: PropTypes.number.isRequired,
  employerUserId: PropTypes.number.isRequired,
};

EmployerJobHub.defaultProps = {
  applications: PropTypes.isNull,
};

export default EmployerJobHub;
